// Refresh/Update Cart Function
async function refreshCart(cart,product_id){
  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: '.product-form--button',
    productVariantId: `${product_id}`,
    cartData: cart,
  });

  // Update cart count bubble
  const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
  const cartData = await cartResponse.json();
  const cartBubble = document.querySelector(".cart-count-bubble span");
  let insertHead = document.querySelector('.drawer__heading span');
  insertHead.innerHTML = `(${cartData.item_count})`
  if (cartBubble) {
    cartBubble.innerHTML = cartData.item_count;
  } else {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.insertAdjacentHTML("beforeend", `
      <span class="visually-hidden">Cart</span>
      <div class="cart-count-bubble">
        <span aria-hidden="true">${cartData.item_count}</span>
        <span class="visually-hidden">${cartData.item_count} items</span>
      </div>
    `);
  }
  if(cartData.item_count == 0){
    document.querySelector('cart-drawer.drawer').classList.add('is-empty');
  }else{
    if(theme.enbled_upsell_product){
      product_upsell(cart)
    }
  }
}

// FREE Product Add/Remove function
function free_productFn() {
	fetch("/cart.js", {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	})
		.then((response) => {
			return response.json();
		})
		.then((cart_data) => {
			var main_sku = theme.main_product.split(",");
			var theme_free_product = theme.free_product;
			var cart_total = cart_data.total_price;
			var free_product = cart_data.items.filter((item) => item.id === theme_free_product && item.properties["_gift_product"] == "true");
			
			// Default matches (for non-collection based)
			var match_product = cart_data.items.filter((item) => main_sku.indexOf(item.sku) !== -1 && item.properties["_gift_product"] != "true") || [];
			
			// Collection based variables
			var collection_match_product = [];
			var collection_products_total = 0;
			
			if (theme.collection_based && theme.selected_collection && theme.selected_collection.length > 0) {
				var collection_product_ids = theme.selected_collection.map(product => product.id);
				collection_match_product = cart_data.items.filter((item) => 
					collection_product_ids.indexOf(item.product_id) !== -1 && 
					item.properties["_gift_product"] != "true"
				) || [];
				
				collection_products_total = collection_match_product.reduce((total, item) => total + (item.line_price || 0), 0);
			}

			// Determine if free product should be added or removed
			var should_add_free_product = false;
			
			if (theme.free_product_enable) {
				if (theme.collection_based) {
					// Rule 2 & 3: Collection based
					if (collection_match_product.length > 0) {
						if (theme.thresold_based) {
							// Rule 3: Collection + Threshold
							should_add_free_product = collection_products_total >= theme.thresold;
						} else {
							// Rule 2: Collection only
							should_add_free_product = true;
						}
					}
				} else {
          console.log("cart_total::",cart_total,theme.thresold)
					// Rule 1: Threshold based OR SKU based
					if (theme.thresold_based) {
						// Rule 1: Threshold based - consider cart total
						should_add_free_product = cart_total >= theme.thresold;
					} else {
						// SKU based (original logic)
						should_add_free_product = match_product.length > 0;
					}
				}
			}

			// Execute add or remove
			if (should_add_free_product && free_product.length == 0) {
				addFreeProd();
			} else if (!should_add_free_product && free_product.length > 0) {
				free_product_remove();
			}

			function free_product_remove() {
				var freeProdId = free_product[0].key;
				$.ajax({
					type: "POST",
					url: "/cart/change.js",
					data: { id: freeProdId, quantity: 0 },
					dataType: "json",
					success: function () {
						$.ajax({
							url: "/cart.js",
							dataType: "json",
							cache: false,
							success: function (cart) {
								if ($("body").hasClass("cart")) {
									window.location.reload();
								} else {
									refreshCart(cart, freeProdId);
								}
							},
						});
					},
				});
			}

			function addFreeProd() {
				$.ajax({
					type: "POST",
					url: "/cart/add.js",
					data: {
						items: [{
							id: theme_free_product,
							quantity: 1,
							properties: { _gift_product: "true" },
						}],
					},
					dataType: "json",
					success: function () {
						$.ajax({
							url: "/cart.js",
							dataType: "json",
							cache: false,
							success: function (cart) {
								if ($("body").hasClass("cart")) {
									window.location.reload();
								} else {
									refreshCart(cart, theme_free_product);
								}
							},
						});
					},
				});
			}
		})
		.catch((error) => {
			console.error("Free product error:", error);
		});
}

if (theme.free_product_enable) {
	free_productFn();
	document.addEventListener(PUB_SUB_EVENTS.custom_addToCart, () => {
		free_productFn();
	});
}

// BOGO OFFER

var gwp_variant_id = parseFloat(theme.bogo_product_offer),/* variant id of Free brush product*/
  main_product = theme.bogo_product_qualifier; /* variant id of brow paste*/
let isUpdate = false;
function bogo_offer(cart){
  
  var has_free_prod = [];
  var cartItems = cart.items,
      qtyInTheCart = 0,
      cartUpdates = {};
  var has_main_prod = $.grep(cartItems,function(ele,index){return ele.id == main_product});
  has_free_prod = $.grep(cartItems,function(ele,index){return ele.variant_id == gwp_variant_id});
  var has_offer2_prods = $.grep(cartItems,function(ele,index){return ele.properties != null && Object.keys(ele.properties).length != 0 && ele.properties.offer=="Offer 2"});
  var has_No_offer_prods = $.grep(cartItems,function(ele,index){return ele.properties != null && Object.keys(ele.properties).length == 0 & ele.id == main_product});
  
  
  
  
  if(has_offer2_prods.length==1 && (has_No_offer_prods.length == 1 || has_No_offer_prods.length == 0)){
    cartUpdates= `updates[${has_offer2_prods[0].id}]=0`;
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: cartUpdates,
      dataType: 'json',
      success: function(cart_data) {
        bogo_offer2(cart_data);
      }
    };
    $.ajax(params);
  }
  else{
    
    if(has_main_prod.length>0){
      if(has_free_prod.length>0){
        cartUpdates = "updates["+gwp_variant_id+"]=1";
        
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: cartUpdates,
          dataType: 'json',
          success: function(cart_data) {
            bogo_offer2(cart_data);
          }
        };
        $.ajax(params);

      }
      else{
        
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: {id:gwp_variant_id, quantity: 0 },
          dataType: 'json',
          success: function(cart) {
            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: {id:gwp_variant_id,quantity:1,properties:{'offer':'Offer 1'}},
              dataType: 'json',
              success: function(cart1) {
                $.ajax({
                  url: '/cart.js',
                  dataType: "json",
                  cache: !1,
                  success: function(cart_data) {
                    bogo_offer2(cart_data);
                  }
                })
              }
            };
            $.ajax(params);
          }
        };
        $.ajax(params);
      }
    }
    else{
      if(has_free_prod.length>0){
        cartUpdates = "updates["+gwp_variant_id+"]=0";
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: cartUpdates,
          dataType: 'json',
          success: function(cart_data) {
            bogo_offer2(cart_data);
          }
        };
        $.ajax(params);
      }
    }
  }

}
function bogo_offer2(cart){
  var has_main_prod = $.grep(cart.items,function(ele,index){return ele.id == main_product && Object.keys(ele.properties).length == 0 });
  /*Next, other offer logic when Brow paste's qty>1 */
  var total_main_qtys = has_main_prod.reduce(function(sum, current) {
    return sum + current.quantity;
  }, 0);
  var updates = cart.items.map(i=>{
    return i.quantity;
  }); 
  if(has_main_prod.length>0 && total_main_qtys>1){
    
    var newQty = Math.ceil(total_main_qtys/2),
        prevQty = total_main_qtys-newQty,
        new_varid = has_main_prod[0].id;
    var offer2_id = $.grep(cart.items,function(item){
      return (item.id == new_varid && item.properties.offer == "Offer 2");
    });
    
    if(offer2_id.length>0){
      cartUpdates = "updates["+offer2_id[0].id+"]=0";
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: cartUpdates,
        dataType: 'json',
        success: function(cart_data) {
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: {id:new_varid,quantity:prevQty,properties:{'offer':'Offer 2'}},
            dataType: 'json',
            success: function(cart1) {
              $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: !1,
                success: function(cart_data) {
                  ($('body').hasClass('cart')?window.location.reload(true):refreshCart(cart_data,new_varid))
                }
              })
            }
          };
          $.ajax(params);
        }
      };
      $.ajax(params);
    }
    else{
      //minus 1 qty from main prod and add additional 1 qty as free product with properties
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {id:new_varid,quantity:prevQty,properties:{'offer':'Offer 2'}},
        dataType: 'json',
        success: function(cart1) {
          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: !1,
            success: function(cart_data) {
              ($('body').hasClass('cart')?window.location.reload(true):refreshCart(cart_data,new_varid))
            }
          })
        }
      };
      $.ajax(params);
    }
  }
  else{
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => {
      return response.json();
    })
    .then(cart_data => {
      ($('body').hasClass('cart')?window.location.reload(true):refreshCart(cart_data,null))
    })
    .catch((error) => {
      
    });

  }
}

if(theme.bogo_product_offer  && theme.bogo_product_qualifier){
  document.addEventListener(PUB_SUB_EVENTS.custom_addToCart, () => {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      // 
      bogo_offer(response);
      if(theme.enbled_upsell_product){
        product_upsell(response)
      }
    })
    .catch((error) => {
      
    });
  });
}

async function getCARTData(){
  const cartResponse = await fetch(window.Shopify.routes.root + "cart.js");
  const cartData = await cartResponse.json();

  if(theme.enbled_upsell_product){
    product_upsell(cartData)
  }
}
// Upsell Products JS
document.addEventListener(PUB_SUB_EVENTS.custom_addToCart, () => {
  getCARTData()
})
$(document).ready( function(){
  getCARTData()
})
if(theme.enbled_upsell_product){
  function product_upsell(cart){
    if(cart.item_count > 0){
      var found_upsell_product = [];
            $.each(cart.items, function(index, product) {
              var found_upsell = false;
              $.each(theme.upsell_products, function(index,ele) {
                if(product.product_id == ele.upsell_parent_id){
                  found_upsell = true;
                  found_upsell_product.push(ele);
                }
              });
            })
            found_upsell_product = getDistinct(found_upsell_product);
            
            var upsellCount = found_upsell_product;
            var last_upsell=[];
            $.each(found_upsell_product,function(inx,ele){
              var matching=false;
              $.each(cart.items, function(index, product) {
                if(product.variant_id==ele.upsell_variant_id){
                  matching=true;
                }
              })
              if(matching==false){
              //  console.log(product.variant_id,ele.upsell_variant_id,product.variant_id==ele.upsell_variant_id)
                last_upsell.push(ele);
              }
            })
            last_upsell=getDistinct(last_upsell);
            if(last_upsell.length > 3){
              upsellCount = last_upsell.slice(0,3);
            }
            else{
              upsellCount=last_upsell;
            }
          if(upsellCount.length > 0){
              var str_upsell = `<div class="upsell_products upsellslider-upsell" data-section-id="upsell" ><div class="product-block--upsell-products">`;
              $.each(upsellCount,function(index,ele){
                var title = theme.upsell_title;
                title = title.replaceAll("XX",ele.upsell_title)
                .replaceAll("YY",ele.upsell_parent_title)
                .replaceAll("$$",ele.upsell_price)
                str_upsell+= `<div class="upsell_rebuy-addon__item">
                      <div class="upsell_addon__item_image"><a href="${ele.upsell_url}"><img src="${ele.upsell_image}" /></a></div>
                      <div class="upsell_addon__item-info">
                      <a href="${ele.upsell_url}"><p class="upsell_addon__item-product-price">${title}</p></a>
                      </div>
                      <div class="add_cart_btn"><button class="btn" data-id="${ele.upsell_variant_id}">add</button></div>
                      </div>`;  
              })
              str_upsell+=`</div></div>`;
              $('.js-upsell-wrapper').empty().append(str_upsell);
            }else{
              $('.js-upsell-wrapper').empty()
            }
      if(upsellCount.length>1){
        var slick_prev_arrow = `
          <span class='slick-prev-arrow slick-arrow'>
            <svg width='26' height='23' viewBox='0 0 26 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M23.7252 11.4859H3.13421' stroke='#453536' stroke-width='3' stroke-linecap='square' stroke-linejoin='round'/>
              <path d='M10.8594 20.0566L2.27981 11.477L10.8594 2.89746' stroke='#453536' stroke-width='3' stroke-linecap='square'/>
            </svg>
          </span>`;
        var slick_next_arrow = `
        <span class='slick-next-arrow slick-arrow'>  
          <svg width='26' height='22' viewBox='0 0 26 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1.79046 10.9994L22.3814 10.9994' stroke='#453536' stroke-width='3' stroke-linecap='square' stroke-linejoin='round'/>
            <path d='M14.6563 2.42877L23.2358 11.0083L14.6562 19.5879' stroke='#453536' stroke-width='3' stroke-linecap='square'/>
          </svg>
        </span>`
        $('.product-block--upsell-products').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: true,
          prevArrow: slick_prev_arrow,
          nextArrow: slick_next_arrow        
        })
        }
    }else{
      $('.js-upsell-wrapper').empty();
    }
  }
}

$(document).on('click','.upsell_rebuy-addon__item .add_cart_btn .btn', function(){
  var id = $(this).attr('data-id'),
      btn= $(this);
  var btn_text = $(this).text();
  btn.text('Adding...').attr('disabled','disabled')
  let formData = {
    'items': [{
      'id': parseFloat(id),
      'quantity': 1,
        properties: {
          '_cart_upsell':true
        }
    }]
  };
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(cart_data) {          
      btn.text('Add').removeAttr('disabled')         
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: !1,
        success: function(cart) {
          // To trigger the Event
          document.dispatchEvent(custom_addToCart);
          if ($("body").hasClass("cart")) {
            window.location.reload();
          } else {
            refreshCart(cart,parseFloat(id))
          }            
          free_productFn();
        }
      })
    }
  };
  $.ajax(params);    
})
document.addEventListener(PUB_SUB_EVENTS.custom_addToCart, () => {
       fetch("/cart.js", {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
          },
      })
      .then((response) => response.json())
      .then((cart_data) => {
          // Create an object to group products by _bundle_id
          const groupedProducts = cart_data.items.reduce((acc, item) => {
              const bundleId = item.properties._bundle_id;
              if (bundleId) {
                  // If the group doesn't exist, create an empty array for it
                  if (!acc[bundleId]) {
                      acc[bundleId] = [];
                  }
                  // Push the item to the corresponding group
                  acc[bundleId].push(item);
              }
              return acc;
          }, {});
      
          // Filter out groups where the length is less than 2
          const filteredGroups = Object.keys(groupedProducts)
              .filter((key) => groupedProducts[key].length < 2)
              .reduce((res, key) => {
                  res[key] = groupedProducts[key];
                  return res;
              }, {});
      
          // If filteredGroups is not empty, remove _bundle_product from the products
          if (Object.keys(filteredGroups).length > 0) {
              Object.keys(filteredGroups).forEach((key) => {
                  filteredGroups[key].forEach((item) => {
                      if (item.properties._bundle_product) {
                          updateBundle(item.key, item.quantity)
                      }
                  });
              });      
          }
      })
      .catch((error) => {
          console.error("Error fetching cart data:", error);
      });
  })
  function updateBundle(key ,quantity){
    var data = {
        id: key,
        quantity: quantity,
        properties:{
          '_bundle_product':'false'
        }
    };
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function (product) {
            $.ajax({
                url: "/cart.js",
                dataType: "json",
                cache: !1,
                success: async function (cart) {
                 if ($("body").hasClass("cart")) {
                        window.location.reload();
                 } else {
                   refreshCart(cart,key)
                  }
                },
            });
        },
    });
   
  }
$(document).ready(function(){
  $('.vat-edit-link').on('click',function(){
    $('.vat-number-form').show()
    $(this).hide()
  })
  $('.vat-cancel-link').on('click',function(){
    $('.vat-number-form').hide()
      $('.vat-edit-link').show()
    
  })
})